import { create } from 'zustand';

type ToastType = 'info' | 'success' | 'error';

interface ToastState {
  message: string;
  type: ToastType;
  isVisible: boolean;
  showToast: (message: string, type?: ToastType, duration?: number) => void;
  hideToast: () => void;
}

let hideTimeout: ReturnType<typeof setTimeout> | null = null;

export const useToastStore = create<ToastState>((set) => ({
  message: '',
  type: 'info',
  isVisible: false,
  showToast: (message, type = 'info', duration = 4000) => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }
    set({ message, type, isVisible: true });
    hideTimeout = setTimeout(() => {
      set({ isVisible: false });
    }, duration);
  },
  hideToast: () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }
    set({ isVisible: false });
  },
}));


